export default __webpack_public_path__ + "static/media/radiodot.14cfb19b.svg";